/**
 * Muze carousel controller, shared by the "Best of" product row and the
 * category row (any section root carrying data-muze-carousel).
 *
 * The track is a native scroll-snap strip; this script only wires the header
 * prev/next arrows to it, keeps their disabled state in step with the scroll
 * position (hiding them entirely when nothing overflows), and adds overflow
 * arrows to swatch strips that don't fit.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BEHAVIOR = REDUCED ? 'auto' : 'smooth';

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  /* ---------- main track ---------- */

  function initCarousel(root) {
    var track = root.querySelector('[data-mbo-track]');
    var prev = root.querySelector('[data-mbo-prev]');
    var next = root.querySelector('[data-mbo-next]');
    if (!track || !prev || !next) return;

    function step() {
      var tiles = track.children;
      if (tiles.length < 2) return track.clientWidth;
      // Tile width plus the flex gap, measured rather than assumed.
      return tiles[1].offsetLeft - tiles[0].offsetLeft;
    }

    function update() {
      var overflowing = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = !overflowing;
      next.hidden = !overflowing;
      if (!overflowing) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: BEHAVIOR });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: BEHAVIOR });
    });

    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  }

  /* ---------- swatch strips ---------- */

  function initSwatches(strip) {
    var track = strip.querySelector('[data-mbo-swatch-track]');
    var prev = strip.querySelector('[data-mbo-swatch-prev]');
    var next = strip.querySelector('[data-mbo-swatch-next]');
    if (!track || !prev || !next) return;

    function update() {
      var overflowing = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = !overflowing;
      next.hidden = !overflowing;
      if (!overflowing) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: BEHAVIOR });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: BEHAVIOR });
    });

    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  }

  /* ---------- boot ---------- */

  function init(scope) {
    scope.querySelectorAll('[data-muze-carousel]').forEach(function (root) {
      if (root.dataset.mboReady) return;
      root.dataset.mboReady = 'true';
      initCarousel(root);
      root.querySelectorAll('[data-mbo-swatches]').forEach(initSwatches);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
